<template>
  <laravel-vue-datatables v-model:columns="columns" v-bind="$attrs" :infinite-scroll="infiniteScroll"
    search-label="Procurar..." search-class="form-input" loader-type="dual" :disable-reload-button="true"
    :disable-skeleton-loader="true" :hoverable="false" :rows-per-page="10"
    table-class="w-full table-auto border-collapse table-fixed" thead-class="bg-gray-100 font-roboto"
    goto-page-class="form-select" rows-per-page-class="form-select" first-page-button-class="text-gray-400"
    last-page-button-class="text-gray-400" previous-page-button-class="text-gray-400"
    next-page-button-class="text-gray-400" loading-bar-class="bg-gray-700" :disableSearch="disableSearch" ref="table">
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
      <slot :key="slot" :name="slot" v-bind="scope" @click="handleClick" />
    </template>

    <template #label.rows-per-page>
      <span class="whitespace-nowrap">Itens por página:</span>
    </template>

    <template #label.pagination="{ from, to, total }">
      <span class="text-bold">Exibindo {{ from }} - {{ to }} de {{ total }} registros.</span>
    </template>

    <template #loader>
      <div class="flex flex-row p-4 bg-white items-center shadow-md">
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        <span class="text-lg">Carregando...</span>
      </div>
    </template>
  </laravel-vue-datatables>
</template>
<script>
import LaravelVueDatatables from './LaravelVueDatatables'

export default {
  components: {
    LaravelVueDatatables,
  },
  props: {
    disableSearch: {
      type: Boolean,
      default: true,
    },
    infiniteScroll: {
      type: Boolean,
      default: false,
    },
  },

  expose: ['reloadData', 'loadNextPage'],

  methods: {
    reloadData() {
      this.$refs.table.getData()
    },
    loadNextPage() {
      if (this.$refs.table && this.$refs.table.loadNextPage) {
        this.$refs.table.loadNextPage()
      }
    }
  },

  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'specialty_name',
          label: 'Nome da especialidade',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'specialty_status',
          label: 'Situação',
          field: 'status',
          visible: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
}
</script>